import { NumberMaterialInput } from 'components/Custom/NumberMaterialInput'
import { Box, Slider } from 'components/Material/index'
import { Control, Controller, Path, FieldValues } from 'react-hook-form'

interface SimpleFloatNumberInputWithSliderProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label: string
  minValue?: number
  maxValue?: number
  adornementText?: string
  errorMessage?: string
}

export const SimpleFloatNumberInputWithSlider = <T extends FieldValues>({
  control,
  name,
  label,
  minValue = 0,
  maxValue = 1000000,
  adornementText,
  errorMessage
}: SimpleFloatNumberInputWithSliderProps<T>) => {
  return (
    <Box className="flex flex-col gap-5">
      <Box className="label-large">{label}</Box>
      <Controller<T>
        control={control}
        name={name}
        render={({ field }) => {
          const value = field.value ?? minValue

          return (
            <>
              <NumberMaterialInput
                {...field}
                value={value}
                label={label}
                fullWidth
                adornment={adornementText}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                  const rawValue = e.target.value.replace(/[^0-9]/g, '')
                  const numericValue = parseFloat(rawValue) / 100
                  const isInvalidValue = numericValue < minValue || numericValue > maxValue!
                  if (isInvalidValue) field.onChange(maxValue)
                }}
                error={!!errorMessage}
                helperText={errorMessage}
              />
              <Slider
                {...field}
                value={value}
                valueLabelDisplay="auto"
                min={minValue}
                max={maxValue}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
                  const rawValue = e.target.value.replace(/[^0-9]/g, '')
                  const numericValue = parseFloat(rawValue) / 100
                  const isInvalidValue = numericValue < minValue || numericValue > maxValue!
                  if (isInvalidValue) field.onChange(maxValue)
                }}
              />
            </>
          )
        }}
      />
    </Box>
  )
}
